import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Submit a lead (Get a Quote / Contact form) to the backend.
export const submitLead = async (payload) => {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
};
